<template>
  <ValidationObserver
    ref="addStudentsModal"
  >
    <b-modal
      id="add-students-modal"
      ref="add-students-modal"
      title="Add Students"
      centered
      no-close-on-backdrop
      ok-title="Add Students"
      :ok-disabled="isLoading"
      cancel-variant="outline-secondary"
      size="sm"
      class="p-0"
      @ok="handleForm"
      @hidden="resetModal"
    >
      <b-overlay
        id="overlay-background"
        :show="isLoading"
        variant="white"
        opacity="1"
        rounded="sm"
      >
        <b-form-group
          label="Students"
          class="mb-2"
        >
          <validation-provider
            #default="{ errors }"
            name="Students"
            rules="required"
          >
            <v-select
              v-model="selectedStudents"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="studentsList"
              multiple
              :close-on-select="false"
              label="full_name"
              :reduce="student => student.user_id"
              placeholder="Select Students"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-overlay>
    </b-modal>
  </ValidationObserver>
</template>

<script>
import {
  BModal,
  BOverlay,
  BFormGroup,
} from 'bootstrap-vue'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import useClassesList from '@/views/admin/academics/classes-list/useClassesList'

export default {
  name: 'AddStudentModal',
  components: {
    BModal,
    BOverlay,
    BFormGroup,

    vSelect,

    ValidationProvider,
    ValidationObserver,
  },
  props: {
    selectedClassId: {
      type: String || null,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      selectedStudents: [],
      studentsList: [],
      required,
    }
  },
  computed: {
    programId() {
      return this.$store.getters['verticalMenu/getDefaultProgram']
    },
  },
  setup() {
    const {
      fetchStudentsForSelectList,
      addStudentsToClass,
    } = useClassesList()

    return {
      fetchStudentsForSelectList,
      addStudentsToClass,
    }
  },
  created() {
    this.prepareStudentsList()
  },
  methods: {
    async prepareStudentsList() {
      const queryParams = {
        exceptGroupId: this.selectedClassId,
        program_id: this.programId,
        sortBy: 'name',
        sortDesc: false,
      }
      this.studentsList = await this.fetchStudentsForSelectList(queryParams)
    },
    handleForm(bvModalEvt) {
      bvModalEvt.preventDefault()

      return new Promise((resolve, reject) => {
        this.$refs.addStudentsModal.validate().then(success => {
          if (success) {
            resolve(true)
            this.handleAddStudent()
          } else {
            reject()
          }
        })
      })
    },
    async handleAddStudent() {
      this.isLoading = true
      const queryParams = {
        program_id: this.programId,
        group_id: this.selectedClassId,
        user_id: this.selectedStudents,
      }

      await this.addStudentsToClass(queryParams)
        .then(() => {
          this.$emit('success')
        })
        .finally(() => {
          this.isLoading = false
          this.$bvModal.hide('add-students-modal')
        })
    },
    resetModal() {
      this.selectedStudents = []
    },
  },
}
</script>

<style>

</style>
